enum EAuthRoutePath {
  SSO_AUTH = '/ssoAuth',
  ADMIN_LOGIN = '/adminLogin',
}

export default EAuthRoutePath;
